import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SISTER_COMPANIES } from "../data/content";
import Reveal from "./Reveal";

const Companies = () => {
  return (
    <section
      id="companies"
      data-testid="companies-section"
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-24 bg-royal"
    >
      <Reveal>
        <div className="flex items-center gap-4 mb-6">
          <span className="h-px w-12 bg-gold" />
          <span className="font-accent text-sm uppercase tracking-[0.28em] text-gold">
            The Group
          </span>
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-display text-beige-light text-4xl md:text-5xl lg:text-6xl leading-[1.08] max-w-3xl mb-14 md:mb-20">
          Explore our sister companies for{" "}
          <span className="italic text-gold-gradient">strategic resourcing.</span>
        </h2>
      </Reveal>

      <div className="border-t border-beige/15">
        {SISTER_COMPANIES.map((c, i) => (
          <motion.a
            key={c.url}
            href={c.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`company-row-${i}`}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.04 }}
            className="group flex items-center justify-between gap-4 border-b border-beige/15 py-6 md:py-8 px-2 md:px-4 hover:px-6 md:hover:px-8 hover:bg-royal-700 transition-all duration-300"
          >
            <div className="flex items-baseline gap-5 md:gap-8 min-w-0">
              <span className="font-accent text-base text-gold/70 tabular-nums">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-display text-xl md:text-3xl text-beige-light truncate group-hover:text-gold transition-colors duration-300">
                {c.name}
              </span>
            </div>
            <div className="flex items-center gap-4 md:gap-8 shrink-0">
              <span className="hidden md:block font-accent text-sm uppercase tracking-[0.24em] text-beige/50">
                {c.sector}
              </span>
              <ArrowUpRight
                size={26}
                className="text-beige/50 group-hover:text-gold group-hover:rotate-45 transition-all duration-300"
              />
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
};

export default Companies;
